export default class Review {
    constructor(name, url, quote) {
        this.name = name;
        this.url = url;
        this.quote = quote;
    }
}
